import { makeStyles } from "@material-ui/core/styles";

// D8.9.1 — Estilos de NotificationAlertsConfig (extraídos del god file).
export const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
    minHeight: "100vh"
  },
  card: {
    marginBottom: theme.spacing(2),
    borderRadius: 12,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.mode === 'dark' 
      ? '0 2px 8px rgba(0,0,0,0.3)' 
      : '0 2px 8px rgba(0,0,0,0.1)'
  },
  sectionTitle: {
    marginBottom: theme.spacing(2),
    fontWeight: 600,
    color: theme.palette.text.primary
  },
  infoBox: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: theme.mode === 'dark' 
      ? 'rgba(33, 150, 243, 0.1)' 
      : 'rgba(33, 150, 243, 0.05)',
    borderRadius: 8,
    border: `1px solid ${theme.mode === 'dark' ? 'rgba(33, 150, 243, 0.3)' : 'rgba(33, 150, 243, 0.2)'}`
  },
  warningBox: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: theme.mode === 'dark' 
      ? 'rgba(255, 152, 0, 0.1)' 
      : 'rgba(255, 152, 0, 0.05)',
    borderRadius: 8,
    border: `1px solid ${theme.mode === 'dark' ? 'rgba(255, 152, 0, 0.3)' : 'rgba(255, 152, 0, 0.2)'}`
  },
  formField: {
    marginBottom: theme.spacing(2)
  },
  actions: {
    display: "flex",
    gap: theme.spacing(1),
    justifyContent: "flex-end",
    marginTop: theme.spacing(3)
  },
  testButton: {
    marginTop: theme.spacing(1)
  },
  testModal: {
    "& .MuiDialog-paper": {
      backgroundColor: theme.palette.background.paper
    }
  },
  testResult: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
    borderRadius: 8
  }
}));
